import { useRef, useState } from "react";
import { Volume2, VolumeX, Instagram } from "lucide-react";
import { mediaUrl as M } from "@/data/pdpMedia";
import { posterUrl } from "@/data/pdpMedia";
import { SectionHeading } from "@/components/common/ui";

export const DayInLife = () => {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
    if (!v.muted) v.play().catch(() => {});
  };

  return (
    <section className="bg-[#FFF0E8] py-24 md:py-32" data-testid="day-in-life">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <SectionHeading
          align="center"
          overline="A Day in the Life"
          title={<span className="md:whitespace-nowrap">Your favourite <span className="text-[#E97C6A]">10 minutes</span> of the day.</span>}
          sub={<span className="md:whitespace-nowrap">Watch Jasmine's wind-down routine and how the Leopard Luxe™ became the ritual she never skips.</span>}
          className="mb-12"
        />

        <div className="relative mx-auto max-w-3xl">
          <div className="group relative overflow-hidden rounded-[2rem] border border-[#F2E8E6] bg-[#232222] shadow-[0_40px_90px_-44px_rgba(62,50,43,0.45)]">
            <div className="relative aspect-video w-full">
              {/* Blurred backdrop fill — same clip, zoomed & blurred to fill the sides */}
              <video
                src={M("pdp_dayinlife")}
                poster={posterUrl("pdp_dayinlife")}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 h-full w-full scale-110 object-cover blur-2xl saturate-[1.15]"
              />
              <div className="pointer-events-none absolute inset-0 bg-black/25" />

              {/* Foreground portrait video — centered, never cropped */}
              <video
                ref={ref}
                src={M("pdp_dayinlife")}
                poster={posterUrl("pdp_dayinlife")}
                data-media-slot="pdp_dayinlife"
                data-media-type="video"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                data-testid="day-in-life-video"
                className="absolute inset-0 z-10 mx-auto h-full w-full object-contain"
              />
            </div>
            <div className="pointer-events-none absolute inset-0 z-20 bg-gradient-to-t from-black/35 via-transparent to-transparent" />

            {/* watch-time pill */}
            <div className="absolute right-5 top-5 z-30 rounded-full bg-[#F2E8E6] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#232222] shadow-sm backdrop-blur-sm" data-testid="day-in-life-duration">
              Watch in 30 sec
            </div>

            {/* Instagram handle */}
            <div className="absolute bottom-5 left-5 z-30 flex items-center gap-2 rounded-full bg-white/90 px-3 py-1.5 shadow-sm backdrop-blur-md" data-testid="day-in-life-handle">
              <Instagram className="h-4 w-4 text-[#C8765A]" />
              <span className="text-sm font-medium text-[#2C2B2C]">@jasmine.glows</span>
            </div>

            <button
              onClick={toggle}
              data-testid="day-in-life-mute"
              aria-label={muted ? "Unmute video" : "Mute video"}
              className="absolute bottom-5 right-5 z-30 flex h-11 w-11 items-center justify-center rounded-full bg-white/85 text-[#2C2B2C] backdrop-blur-md transition-all hover:bg-white"
            >
              {muted ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
